import { j as i, a as n, F } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { useState as a, useLayoutEffect as j } from "react";
import { IonBackdrop as P } from "@ionic/react";
import { translate as m } from "../../string-table.js";
import { Colors as I } from "../../1-foundations/Colors/Colors.js";
import { I as W, g as k } from "../../../Icon-BruFLyVl.js";
import { K as V, E as M, q as U, G as Y } from "../../../FeatureFlagProvider-DSFeeZ8R.js";
import "../../../react-paginate-Lh5zQzpz.js";
import { LoadingInterstitial as q } from "../LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import { LogInButton as w } from "./LoginButton/LoginButton.js";
function rt(o) {
  const {
    apiError: e,
    app: l,
    build: v,
    buildProfile: u,
    history: y,
    isWeb: _,
    loginWithPasswordPath: x,
    signUpPath: O,
    onLoginEmailSubmit: G,
    platform: f,
    version: R
  } = o, {
    signIn: h,
    isAuthenticating: A
  } = V(), [c, p] = a(""), [C, r] = a(), [g, E] = a(!1), [b, L] = a(e);
  j(() => {
    L(e);
  }, [e]);
  const N = (t) => {
    p(t), H(t) ? E(!0) : E(!1);
  }, S = async () => {
    const {
      provider: t,
      shouldSignUp: D
    } = await G(c).catch((d) => r(d));
    if (t)
      switch (t) {
        case "COGNITO":
          r(void 0), y.push({
            pathname: D ? O : x,
            // Explicitly not using `useLocation` as we want to live value vs
            // cached value.
            search: window.location.search,
            state: {
              email: c
            }
          });
          break;
        case "GOOGLE":
          r(void 0), h({
            provider: t.toLowerCase()
          }).catch((d) => {
            r(d);
          });
          break;
      }
  };
  async function T(t) {
    t.preventDefault(), L(void 0), await S();
  }
  async function B(t) {
    t.preventDefault(), r(void 0), p(""), await h({
      provider: "google"
    });
  }
  return /* @__PURE__ */ i(Y, {
    app: l,
    build: v,
    isWeb: _,
    version: R,
    children: A ? /* @__PURE__ */ n("div", {
      children: [/* @__PURE__ */ i(P, {
        visible: !0
      }), /* @__PURE__ */ i("div", {
        css: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 11,
          background: "var(--swing-white200)",
          width: "100%",
          height: "100%",
          borderRadius: 8,
          maxWidth: 360,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: /* @__PURE__ */ i(q, {})
      })]
    }) : /* @__PURE__ */ n(F, {
      children: [/* @__PURE__ */ n("form", {
        css: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 32
        },
        onSubmit: async (t) => await T(t),
        children: [/* @__PURE__ */ i(M, {
          app: l,
          buildProfile: u,
          email: c,
          error: C,
          onEmailInput: (t) => N(t),
          platform: f,
          provider: "cognito",
          readOnly: !1
        }), /* @__PURE__ */ i(w, {
          disabled: !g,
          isFluid: !0,
          hasShadow: !0,
          children: /* @__PURE__ */ n("div", {
            css: s.buttonContentContainer,
            children: [/* @__PURE__ */ i("span", {
              css: {
                ...s.buttonText,
                marginRight: 8
              },
              children: m("LOGIN_EMAIL_ENTRY_LOGIN_LABEL_ENTER_PASSWORD")
            }), /* @__PURE__ */ i(W, {
              name: "Arrow Right",
              color: g ? I.white200 : I.slate400
            })]
          })
        })]
      }), /* @__PURE__ */ i(z, {
        label: m("LOGIN_EMAIL_ENTRY_LABEL_OR")
      }), /* @__PURE__ */ n("form", {
        css: {
          width: "100%"
        },
        onSubmit: async (t) => await B(t),
        children: [/* @__PURE__ */ i(w, {
          variant: "outlined",
          isFluid: !0,
          children: /* @__PURE__ */ n("div", {
            css: s.buttonContentContainer,
            children: [/* @__PURE__ */ i("img", {
              src: k,
              alt: "Login with Google"
            }), /* @__PURE__ */ i("span", {
              css: {
                ...s.buttonText,
                marginLeft: "auto",
                marginRight: "auto"
              },
              children: m("LOGIN_EMAIL_ENTRY_LOGIN_LABEL_CONTINUE_WITH_GOOGLE")
            })]
          })
        }), b && /* @__PURE__ */ i(U, {
          app: l,
          buildProfile: u,
          error: b,
          platform: f
        })]
      })]
    })
  });
}
function z(o) {
  const {
    label: e
  } = o;
  return /* @__PURE__ */ i("div", {
    css: {
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      width: "100%",
      "&::before, &::after": {
        content: '""',
        flex: 1,
        borderBottom: "1px solid var(--swing-gray-200)"
      },
      "&:not(:empty)::before": {
        marginRight: 12
      },
      "&:not(:empty)::after": {
        marginLeft: 12
      }
    },
    children: e
  });
}
function H(o) {
  return new RegExp(/.+@.+\..{2,}/).test(o);
}
const s = {
  buttonContentContainer: {
    display: "flex",
    flexDirection: "row",
    placeItems: "center",
    justifyContent: "center"
  },
  buttonText: {
    fontFamily: "var(--swing-font-family-headers)"
  }
};
export {
  rt as Login,
  H as isValidEmail
};
